import { makeStyles } from "@material-ui/core";
import { useReducer } from "react";
import CustomTabStyle from "../../componentes/tabs/CustomTabStyle";
import CustomTabs from "../../componentes/tabs/CustomTabs";
import { useTranslation } from "react-i18next";
import a11yProps from "../../componentes/tabs/a11Props";
import TabPanel from "../../componentes/tabs/TabPanel";
import FormContainer from "../../componentes/form-container/FormContainer";
import { LabelShippingProduct } from "./LabelShippingProduct";
import { LabelShippingStockLocation } from "./LabelShippingStockLocation";
import { LabelConsult } from "./LabelConsult";
import { LabelOutlined, LocalShippingOutlined, SearchOutlined } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    root: {
        marginRight: 10,
    },
}));

const reducer = (state, data) => {
    return { ...state, ...data }
}

const initialState = {
    id: 0,
    tabValue: 0,
};

const LabelControl = () => {

    const { t } = useTranslation();
    const classes = useStyles();
    const [state, dispatch] = useReducer(reducer, initialState);
    const { id, tabValue } = state
    const handleTabChange = (event, newValue) => dispatch({ tabValue: newValue });

    return (
        <>
            <FormContainer>
                <CustomTabs
                    value={tabValue}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="client tab"
                >
                    <CustomTabStyle
                        label={t("shippingProduct")}
                        {...a11yProps(0)}
                        icon={<LabelOutlined fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("shippingStockLocation")}
                        {...a11yProps(1)}
                        icon={<LocalShippingOutlined fontSize="small" classes={classes} />} />
                    <CustomTabStyle
                        label={t("consult")}
                        {...a11yProps(2)}
                        icon={<SearchOutlined fontSize="small" classes={classes} />} />
                </CustomTabs>
                <TabPanel value={tabValue} index={0}>
                    <LabelShippingProduct />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <LabelShippingStockLocation />
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                    <LabelConsult />
                </TabPanel>
            </FormContainer>
        </>
    )
}

export default LabelControl;